import React, { useContext } from 'react';

interface AccountContextModel {
  locale: string;
}

const AccountContext = React.createContext<AccountContextModel>({
  locale: 'en'
});

export const useAccountContext = () => useContext(AccountContext);

export const AccountContextProvider = AccountContext.Provider;
export const AccountContextConsumer = AccountContext.Consumer;
export default AccountContext;
